import {
  Home,
  Homicidios,
  LesionesPersonales,
  ViolenciaIntrafamiliar,
  DesplazamientoFI,
  DelitosSexuales,
  Hurtos,
  Extorsion,
  Llamadas123,
  Convivencia,
  Operatividad
} from "../components/Pages";

export const routes = [
  { path: "/", element: <Home />, label: "Inicio" },
  { path: "/homicidios", element: <Homicidios />, label: "Homicidios" },
  { path: "/lesiones-personales", element: <LesionesPersonales />, label: "Lesiones personales" },
  { path: "/violencia-intrafamiliar", element: <ViolenciaIntrafamiliar />, label: "Violencia intrafamiliar" },
  //{ path: "/desplazamiento-forzado", element: <DesplazamientoFI />, label: "Desplazamiento forzado interno" },
  { path: "/delitos-sexuales", element: <DelitosSexuales />, label: "Delitos sexuales" },
  { path: "/hurtos", element: <Hurtos />, label: "Hurtos" },
  { path: "/extorsion", element: <Extorsion />, label: "Extorsión" },
  { path: "/llamadas-123", element: <Llamadas123 />, label: "Llamadas 123" },
  //{ path: "/convivencia", element: <Convivencia />, label: "Comportamientos contrarios a la convivencia" },
  { path: "/operatividad", element: <Operatividad />, label: "Operatividad" },
];